export const EXTRA_SMALL = "extraSmall";
export const SMALL = "small";
export const MEDIUM = "medium";
export const LARGE = "large";
